import Typography from "../../../../../componentsNew/Typography";


export default function DescricaoCriterio({ item }) {
    //Utilizar somente em UAT
    //if (item?.statusAnaliseLegibilidade?.mensagemUAT) console.log(item?.statusAnaliseLegibilidade.mensagemUAT)
    return (
        <Typography component="body1-descricao" className="flex flex-col w-full">
            {item?.statusAnaliseLegibilidade &&
                <div className="mb-4 w-full">
                    <b>{item?.statusAnaliseLegibilidade.status}</b> <br />
                    <b>Nota: </b> {item?.statusAnaliseLegibilidade.score.toFixed(1)} <br />
                    <b>Nível: </b> {item?.statusAnaliseLegibilidade.nivel} <br />

                </div>
            }
            <div>
                <b>Descrição: </b> {item?.descricao}
            </div>
            {item?.explicacaoDetalhada && (
                <div className="mt-4">
                    <b>Explicação detalhada: </b> {item?.explicacaoDetalhada}
                </div>
            )}
            {item?.conteudo &&
                <div className="mt-2">
                    {item?.conteudo.map((i, index) => {
                        if (i?.frase && index?.mensagemErro) {
                            return (
                                <div className="mt-2" key={index}>
                                    <b>Ocorrência: </b> {i.frase} <br />
                                    <b>Motivo: </b> {i.mensagemErro}
                                </div>
                            )
                        }

                        if (i?.ocorrencia && i?.recomendacoes?.length > 0) {
                            return (
                                <div className="mt-2" key={index + 1}>
                                    <b>Ocorrência: </b> {i.ocorrencia} <br />
                                    <b>Recomendações: </b>
                                    <span>{i.recomendacoes.toString().replaceAll(",", ", ")} </span><br /><br />
                                </div>
                            )
                        }
                    })}
                </div>
            }
        </Typography>
    );
}

